import { observer } from 'mobx-react';

import {
  MonetizationEventsEventType,
  type MonetizationEventsCurrentEvent,
} from '../../../dto/monetization-events.types';
import { devError } from '../../../utils/log';
import { SportsWidget } from '../SportsDialog/SportsWidget';

import './MonetizationEvents.scss';

export const MonetizationEventWidget = observer(({ event }: { event: MonetizationEventsCurrentEvent }) => {
  switch (event.providerType) {
    case MonetizationEventsEventType.SPORTS:
      return <SportsWidget event={event} />;

    case MonetizationEventsEventType.METAGAMES:
      return <div>TODO</div>;
    default:
      devError(`MonetizationEventWidget onClickHandler error: Unknown event type ${event.providerType}`);
      return null;
  }
});
